import React from 'react'
import ShapeCardImg from '../assets/shape_card.png'
const ShapeCard = ({ className }) => {
    return (
        <div className={`rounded-md p-3  md:w-[420px]  flex items-center gap-4 ${className}`} >
            <div className="card_clip_img w-[200px]">
                <img src={ShapeCardImg} alt="" className='w-full h-full object-cover' />
            </div>
            <div className="w-full">

                <h3 className=' text-[20px] font-quicksand font-bold text-dark' >
                    City break
                </h3>
                <p className=' text-xs font-quicksand font-bold text-dark' >
                    Luca
                </p>
                <p className=' text-xs font-quicksand font-medium text-dark' >
                    Lisancashire cauliflower cheese say cheese brie cut the cheese boursin everyone love.
                </p>
            </div>
        </div>
    )
}
export default ShapeCard
